import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import NavBarRoot from "../../components/molecules/NavBarRoot/NavBarRoot";
import Register from "../../assets/img/Register.png";
import GooglePlay from "../../assets/img/google-play-badge.png";
import Footer from "../../assets/img/Footer.png";

import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import {
  BACKGROUND_KUBBE,
  DARK_KUBBE,
  PRIMARY_KUBBE,
  SECONDARY_KUBE,
} from "../../constants/Colors";
import FlowSection from "./components/FlowSection";
import WhoSection from "./components/WhoSection";
import ContactForm from "./components/ContactForm";
import Accordion from "./components/Accordion";
import { faqData } from "./FAQ";
import { playUrl } from "../Dashboard/components/AppLink/AppLink";
import { useHistory, useLocation } from "react-router-dom";

const DivBackground = styled.div`
  width: 100%;
  min-height: 100vh;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  padding-right: 30px;
  padding-left: 30px;
  @media (max-width: 991px) {
    padding-right: 10px;
    padding-left: 10px;
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  cursor: pointer;
  img {
    width: 100%;
    object-fit: cover;
  }
`;

const GoogleWrapper = styled.div`
  width: 100%;
  cursor: pointer;
  padding: 20px 0px 50px 0px;
  text-align: center;
  img {
    height: 60px;
    width: auto;
    object-fit: cover;
  }
`;

const FAQContainer = styled.div`
  padding: 30px;
`;
const Arrow = styled.span`
  position: absolute;
  color: ${BACKGROUND_KUBBE};
  top: 50%;
  right: 0;
  transform: translateY(-50%) translateX(-70%)
    ${({ open }) => (open ? "rotate(180deg)" : "rotate(0deg)")};
  transition: transform 0.3s ease;
  @media (max-width: 991px) {
    transform: translateY(-50%) translateX(-100%);
  }
`;

const FAQButton = styled.button`
  background-color: ${PRIMARY_KUBBE};
  color: ${DARK_KUBBE};
  font-weight: 900;
  font-size: clamp(1.2rem, 1.5vw, 1.8rem);
  border-radius: 10px;
  padding: 10px 50px;
  margin-bottom: 2rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: auto;
  position: relative;

  &:hover {
    opacity: 0.9;
  }
`;

const FooterWrapper = styled.div`
  width: 100%;
  background-color: ${DARK_KUBBE};
  padding: 20px 30px;
  display: flex;
  align-items: center;
  position: relative;

  .footer-img {
    height: clamp(20px, 5vw, 50px);
    object-fit: cover;
    margin: 0 auto;
  }

  .qr-link {
    position: absolute;
    right: 30px;
  }

  .qr-img {
    height: clamp(30px, 6vw, 60px);
    object-fit: contain;
    cursor: pointer;
  }
`;

const Home = (props) => {
  const history = useHistory();
  const [showFAQ, setShowFAQ] = useState(false);
  const location = useLocation();
  const contactRef = useRef(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("scroll") === "contact" && contactRef.current) {
      contactRef.current.scrollIntoView({ behavior: "smooth" });
      history.replace("/");
    }
  }, [location.search, contactRef, history]);

  return (
    <>
      <DivBackground style={{ background: BACKGROUND_KUBBE }}>
        <header>
          <NavBarRoot />
        </header>
        <HeroSection />
        <FeaturesSection />
        <FlowSection />
        <ImageWrapper
          onClick={() => {
            history.push("/which-user");
            window.scrollTo(0, 0);
          }}
        >
          <img src={Register} alt="Registro nuevos clientes" />
        </ImageWrapper>
        <WhoSection />

        <FAQContainer>
          <FAQButton
            onClick={() => {
              setShowFAQ(!showFAQ);
              /* history.push("/faq");
              window.scrollTo(0, 0); */
            }}
          >
            PREGUNTAS FRECUENTES
            {showFAQ && <Arrow open={showFAQ}>▼</Arrow>}
          </FAQButton>
          <div
            style={{
              maxHeight: showFAQ ? "2000px" : "0px",
              overflow: "hidden",
              transition: "max-height 0.6s ease-in-out",
            }}
          >
            <Accordion data={faqData} />
          </div>
        </FAQContainer>
        <GoogleWrapper>
          <a href={playUrl} target="_blank" rel="noopener noreferrer">
            <img src={GooglePlay} alt="Disponible GooglePlay" />
          </a>
        </GoogleWrapper>
      </DivBackground>
      <ContactForm ref={contactRef} />
      <footer>
        <FooterWrapper>
          <img src={Footer} alt="footer" className="footer-img" />
          <a
            className="qr-link"
            href="http://qr.afip.gob.ar/?qr=NN3I8Igmw5BdIr3kjDDf9A,,"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="http://www.afip.gob.ar/images/f960/DATAWEB.jpg"
              alt="Data Fiscal AFIP"
              className="qr-img"
            />
          </a>
        </FooterWrapper>
      </footer>
    </>
  );
};

export default Home;
